import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const isAuthAvailable = !!(supabaseUrl && supabaseAnonKey);

if (!isAuthAvailable) {
  console.warn('Supabase env vars not set — auth features disabled');
}

export const supabase = isAuthAvailable
  ? createClient(supabaseUrl!, supabaseAnonKey!, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        storageKey: 'dombase-auth',
      },
    })
  : null;

export type Plan = 'free' | 'premium';

export interface Profile {
  id: string;
  plan: Plan;
  stripe_customer_id: string | null;
  stripe_subscription_id: string | null;
  created_at: string;
}
